import { useEffect, useState } from 'react';

/**
 * Seconds elapsed since `startISO`, ticking once per second. Returns 0 when
 * `startISO` is nullish or unparseable. The interval is cleared on unmount and
 * whenever `startISO` changes — used to drive the live on-call timer.
 */
export function useElapsed(startISO?: string | null): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!startISO) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [startISO]);

  if (!startISO) return 0;
  const start = new Date(startISO).getTime();
  if (Number.isNaN(start)) return 0;
  return Math.max(0, Math.floor((now - start) / 1000));
}
